export const getMarkerStyle = (soilType, isTempSoilType) => {
  let fillColor;
  let borderColor;

  // soilType에 따른 내부 색상 설정
  switch (soilType) {
    case 'S1':
      fillColor = '#1f77b4'; // 파란색
      break;
    case 'S2':
      fillColor = '#2ca02c'; // 초록색
      break;
    case 'S3':
      fillColor = '#ff7f0e'; // 주황색
      break;
    case 'S4':
      fillColor = '#d62728'; // 빨간색
      break;
    case 'S5':
      fillColor = '#9467bd'; // 보라색
      break;
    default:
      fillColor = '#7f7f7f'; // 기본 회색
  }

  // isTempSoilType에 따른 테두리 색상 설정
  borderColor = isTempSoilType ? 'yellow' : '#000000'; // 임시 지반일 때 노란 테두리

  return { fillColor, borderColor };
};

